import { render, staticRenderFns } from "./ClientFlashMessage.vue?vue&type=template&id=6bd24783&scoped=true&"
import script from "./ClientFlashMessage.vue?vue&type=script&lang=ts&"
export * from "./ClientFlashMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientFlashMessage.vue?vue&type=style&index=0&id=6bd24783&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd24783",
  null
  
)

export default component.exports